import React from 'react';
import { Box } from '@mui/material';
import { HeroSection } from '../../components/marketing/HeroSection';
import { ValueProposition } from '../../components/marketing/ValueProposition';
import { ReportContents } from '../../components/marketing/ReportContents';
import { MarketExplorer } from '../../components/marketing/MarketExplorer';
import { PrimaryCTA } from '../../components/marketing/PrimaryCTA';
import { Testimonial } from '../../components/marketing/Testimonial';
import { SecondaryFeatures } from '../../components/marketing/SecondaryFeatures';
import { FooterCTA } from '../../components/marketing/FooterCTA';

export const MarketingDashboard: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        fontFamily: '"Inter", "Helvetica Now", "Helvetica", "Arial", sans-serif',
        mx: -3, // Counteract the Layout's padding
        my: -3, // Counteract the Layout's padding on top and bottom
      }}
    >
      <HeroSection />
      <ValueProposition />
      <ReportContents />
      <MarketExplorer />
      <PrimaryCTA />
      <Testimonial />
      <SecondaryFeatures />
      <FooterCTA />
    </Box>
  );
};